/* helper — compute derived fields */
export const withDerived = (row) => {
  const profit = Number(row.profit) || 0;
  const keitaroProfit = Number(row.keitaroProfit) || 0;
  const fluxarProfit = Number(row.fluxarProfit) || 0;
  const spentIo1 = Number(row.spentIo1) || 0;
  const anotherSpent = Number(row.anotherSpent) || 0;
  const spentIo1Pending = Number(row.spentIo1Pending) || 0;
  const spentIo15Pending = Number(row.spentIo15Pending) || 0;

  const totalProfit = profit + keitaroProfit + fluxarProfit;
  const spentAll = spentIo1 + anotherSpent;
  const netProfit = totalProfit - spentAll;
  const roi = spentAll > 0 ? (netProfit / spentAll) * 100 : 0;
  // Pending (Karta) — tracked separately, never mixed into settled totals
  const pendingSpentAll = spentIo1Pending + spentIo15Pending;

  return {
    ...row,
    profit,
    keitaroProfit,
    fluxarProfit,
    spentIo1,
    anotherSpent,
    spentIo1Pending,
    spentIo15Pending,
    totalProfit,
    spentAll,
    netProfit,
    roi,
    pendingSpentAll,
  };
};

